'use client';

import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createMnoTheme } from '@/theme/createMnoTheme';
import { useMnoContext } from '@/context/MnoContext';

interface MnoThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Provider that creates and applies MNO-specific Material-UI theme
 * This provider consumes the MNO config from MnoContext and creates a Material-UI theme
 * Must be used within MnoProvider
 */
export function MnoThemeProvider({ children }: MnoThemeProviderProps) {
  const { config } = useMnoContext();
  
  const theme = useMemo(() => {
    return createMnoTheme(config);
  }, [config]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

